import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-software-development',
  templateUrl: './custom-software-development.component.html',
  styleUrls: ['./custom-software-development.component.scss']
})
export class CustomSoftwareDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
